import { ReactElement } from "react";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { IoChevronDown, IoGlobeOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

type Props = {
  to: string;
};

export function LanguageSelector(props: Readonly<Props>): ReactElement {
  return (
    <Menu computePositionOnMount>
      <MenuButton
        as={Button}
        data-testid="language-selector"
        margin="10px 0"
        leftIcon={<IoGlobeOutline />}
        variant="ghost"
        borderRadius={0}
        bg="primary.bg_lv1"
        _hover={{ backgroundColor: "primary.theme_lv3" }}
        _active={{ backgroundColor: "primary.theme_lv3" }}
      >
        <Flex alignItems="center" columnGap={2}>
          <IoChevronDown />
        </Flex>
      </MenuButton>
      <MenuList borderRadius={0} backgroundColor="common.base">
        <MenuItem
          as={Link}
          data-testid="language-ja"
          to={`/ja/${props.to}`}
          color="text.subtext"
          _focus={{ backgroundColor: "primary.bg_lv1" }}
        >
          日本語
        </MenuItem>
        <MenuItem
          as={Link}
          data-testid="language-en"
          to={`/en/${props.to}`}
          color="text.subtext"
          _focus={{ backgroundColor: "primary.bg_lv1" }}
        >
          English
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
